// [AI generated. Not yet reviewed by human.]
// Remembers the page a signed-out user tried to open, so they can be sent back there after login.
// sessionStorage is used because sign-in is a full-page redirect to Atlassian/Microsoft, which
// wipes React Router state; it is per-tab and survives that round trip. Only a same-origin path
// is stored here — never a token. See login-redirect-back-standard.md.
import { APP_URLS } from "../constants/appConstants";

export const REDIRECT_AFTER_LOGIN_KEY = "redirectAfterLogin";

const AUTH_PATHS = [APP_URLS.SIGN_IN, APP_URLS.SIGN_IN_CALLBACK, APP_URLS.MS_SIGN_IN_CALLBACK].map(
    (path) => `/${path}`,
);

// Accept only in-app paths ("/..."), never "//host" or "/\host" which browsers treat as another origin,
// and never the auth pages themselves (returning there would loop).
export const isSafeRedirectPath = (path: string | null | undefined): path is string => {
    if (!path || !path.startsWith("/") || path.startsWith("//") || path.startsWith("/\\")) {
        return false;
    }
    const pathname = path.split(/[?#]/)[0];
    return !AUTH_PATHS.includes(pathname);
};

export const saveRedirectPath = (path: string): void => {
    if (isSafeRedirectPath(path)) {
        sessionStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, path);
    }
};

export const clearRedirectPath = (): void => {
    sessionStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
};

// Returns the saved path (or null) and removes it, so it is used only once.
export const consumeRedirectPath = (): string | null => {
    const path = sessionStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
    clearRedirectPath();
    return isSafeRedirectPath(path) ? path : null;
};

export const getCurrentPath = (): string => {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};
